$(document).ready(function(){
  $('#campaign-list-table').DataTable();
  var raised = $('.chart-data').attr("data-total-raised");
  var needed = $('.chart-data').attr("data-total-needed");
  var over =   $('.chart-data').attr("data-over");

  var chartcanvas = document.getElementById('chart-area').getContext('2d');
  var config = {
      type: 'doughnut',
      data:{
        datasets: [{
          label: 'Goals',
            data: [raised, needed, over],
            backgroundColor:['rgba(216, 239, 83, 1)','rgba(6, 211, 180, 1)', 'rgb(233, 106, 24)'],
            borderWidth:0
          }],
        labels: ['Raised', 'Needed', 'Over']
      }
    };
  var LatestGoal = new Chart(chartcanvas, config);

});
